module.exports = __webpack_public_path__ + "img/monsor1.f66f4279.jpg";